import { fetch } from 'whatwg-fetch';
import cognitoAuth from '../../utils/cognitoAuth.mjs';
import salesforceConfig from '../../utils/salesforceConfig.mjs';
import toResponse from './toRes.mjs';

const getAccountInfo = async (uuid, setLookupInfo, setLoadingCompanyInfo, isMockMode) => {
  try {
    setLoadingCompanyInfo(true);
    const token = await cognitoAuth();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    }
    const body = JSON.stringify({
      command: 'SalesforceGuideSearch',
      uuid,
      sendPii: true,
    });
    const mockResponse = {
        uuid:"5c4311255aaf",
        userInfo: {
          lastName: "Pravesh",
          firstName: "Devon",
          email: "decon@testemail.com",
          contactPhone: "9728888888",
          contactId: "003R000001fRujFIAS",
          companyPhone: "9728888888",
          company: "Ignite Sales",
          address: { 
            zipcode: "72325",
            street: "1101 Ignite Rd",
            state: "TX",
            country: "United States",
            city: "Dallas"
          },
        accountId: "001R000002CoaAEIAZ"
      },
      status: 200,
      name: "Small Business CARA",
      message: "success"
    }
     const response = await fetch(salesforceConfig().salesforceUrl, {method: 'POST', headers, body});
    
    const res = isMockMode ? mockResponse : await response.json();
    const key = `${uuid}-localAnswers`;
    if (res.userInfo) {
      const data = {
        appkey: 'companyLookup',
        timestamp: new Date(),
        value: toResponse(res.userInfo)
      }
      window.sessionStorage.setItem(
        key,
        JSON.stringify({
          companyLookup: data
        })
      )
      setLookupInfo({
        company: data.value,
        contact: undefined
      });

      setLoadingCompanyInfo(false);
    } else {
      console.log('error: ', res.message);
      setLoadingCompanyInfo(false);
    }
  } catch (e) {
    console.log('error: ', e);
    setLoadingCompanyInfo(false);
  }
}

export default getAccountInfo;